import { TourStep } from './schema.type';

export interface IStepState {
    selectedStep: TourStep;
}

export const initStepState: IStepState = {
    selectedStep: new TourStep(),
};
